import { HttpClient } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk'
import { EmbeddingContext } from 'amazon-quicksight-embedding-sdk/dist'
import { User } from 'common/class/user'
import { Logger } from 'common/utility/logger/logger'
import { take } from 'rxjs'
import { StorageService } from 'services/storage/storage.service'
import { Environment } from 'src/environments/environment'


@Component({
  selector: 'ems-reports',
  standalone: false,
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  constructor(private http: HttpClient) { }

  private loggedOnUser: User | undefined = undefined


  private get LoggedOnUser(): User {
    this.loggedOnUser = this.loggedOnUser ?? StorageService.loggedOnUser
    return this.loggedOnUser
  }

  loadingError = false;
  dashboard: any;

  ngOnInit() {
    this.GetDashboardURL();
  }

  public GetDashboardURL() {
    const url: string = `${Environment.ReportsApi}/report?userId=${this.LoggedOnUser?.Id ?? "0000000"}`
    Logger.debug("Logged on user:", this.loggedOnUser?.Id ?? "no id")

    this.http.get(url)
      .pipe(
        take(1),
      )
      .subscribe((data: any) => {
        const reportUrl:string = data.url
        Logger.debug("Connecting to reports with url:", reportUrl)
        this.Dashboard(reportUrl)
      });
  }

  public async Dashboard(embeddedURL: any) {
    var containerDiv = document.getElementById("dashboardContainer") || '';
    const frameOptions = {
      url: embeddedURL,
      container: containerDiv,
      // height: "850px",
      // width: "100%",
      resizeHeightOnSizeChangedEvent: true,
    }
    const embeddingContext: EmbeddingContext = await createEmbeddingContext();
    this.dashboard = embeddingContext.embedDashboard(frameOptions);
  }
}
